
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
// eslint-disable-next-line
const intlTelInput = require('intl-tel-input');

declare global {
  interface Window {
    intlTelInputGlobals: any;
  }
}

export default defineComponent({
  name: 'Input',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: '',
      required: true
    },
    error: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: 12
    }
  },
  emits: ['get-phone-number', 'focus', 'blur'],
  computed: {
    ...mapGetters([
      'global'
    ])
  },
  data() {
    return {
      phoneNumber: ''
    };
  },

  mounted () {
    const input = document.getElementById('tel');
    intlTelInput(input, {
      initialCountry: 'it',
      preferredCountries: ['it'],
      // onlyCountries: ['it', 'fr', 'de', 'gb']
    });
    if(input){
      input.addEventListener('countrychange', () => {
        this.$emit('get-phone-number', this.getPhoneNumberAndCountryCode());
      });
    }
  },
  methods: {
    onLabelClick (label: any) {
      label.srcElement.previousElementSibling.focus();
    },
    getPhoneNumberAndCountryCode() {
      let dialCode = '';
      const input = document.getElementById('tel');
      if (input != null) {
        const iti = window.intlTelInputGlobals.getInstance(input);
        dialCode = iti.getSelectedCountryData().dialCode.toString();    

        return {
          countryCode: `+${dialCode}`,
          number: this.phoneNumber
        };
      }
    },
    sanitizePhoneNumber(event: any) {
      this.phoneNumber = event.target.value.replace(/\D/g, '');
    }
  }
});
